"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DumpsterUpdateInput = exports.DumpsterCreateInput = exports.DumpsterTransport = exports.RailStyleLabels = exports.RailStyle = exports.RailStyles = exports.DumpsterStyleLabels = exports.DumpsterStyle = exports.DumpsterStyles = exports.TrailerTypeLabels = exports.TrailerType = exports.TrailerTypes = exports.DumpsterTypeLabels = exports.DumpsterType = exports.DumpsterTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const container_1 = require("../container/container");
const container_type_1 = require("../container/container-type");
const dumpster_activity_record_transport_1 = require("./dumpster-activity-record-transport");
/**
 * @deprecated Use RollOffVariant from @alliance-disposal/transport-types
 */
exports.DumpsterTypes = container_type_1.RollOffVariants;
exports.DumpsterType = typebox_1.Type.Union(exports.DumpsterTypes.map((m) => typebox_1.Type.Literal(m)));
/**
 * @deprecated Use RollOffVariant from @alliance-disposal/transport-types
 */
exports.DumpsterTypeLabels = container_type_1.RollOffVariantLabels;
/**
 * @deprecated Use TrailerAxleConfiguration from @alliance-disposal/transport-types
 */
exports.TrailerTypes = container_type_1.TrailerAxleConfigurations;
exports.TrailerType = typebox_1.Type.Union(exports.TrailerTypes.map((m) => typebox_1.Type.Literal(m)));
/**
 * @deprecated Use TrailerAxleConfiguration from @alliance-disposal/transport-types
 */
exports.TrailerTypeLabels = container_type_1.TrailerAxleConfigurationLabels;
/**
 * @deprecated Use RollOffLiftStyle from @alliance-disposal/transport-types
 */
exports.DumpsterStyles = container_type_1.RollOffLiftTypes;
exports.DumpsterStyle = typebox_1.Type.Union(exports.DumpsterStyles.map((m) => typebox_1.Type.Literal(m)));
/**
 * @deprecated Use RollOffLiftStyle from @alliance-disposal/transport-types
 */
exports.DumpsterStyleLabels = container_type_1.RollOffLiftTypeLabels;
/**
 * @deprecated Use RollOffRailStyle from @alliance-disposal/transport-types
 */
exports.RailStyles = container_type_1.RollOffRailStyles;
exports.RailStyle = typebox_1.Type.Union(exports.RailStyles.map((m) => typebox_1.Type.Literal(m)));
/**
 * @deprecated Use RollOffRailStyle from @alliance-disposal/transport-types
 */
exports.RailStyleLabels = container_type_1.RollOffRailStyleLabels;
exports.DumpsterTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    container: typebox_1.Type.Optional(container_1.TaggedContainerTransport),
    decal: typebox_1.Type.String(),
    name: typebox_1.Type.String(),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    size: typebox_1.Type.Number(),
    status: typebox_1.Type.String(),
    boxType: exports.DumpsterType,
    railStyle: typebox_1.Type.Optional(exports.RailStyle),
    style: typebox_1.Type.Optional(exports.DumpsterStyle),
    trailerType: typebox_1.Type.Optional(exports.TrailerType),
    currentLocation: typebox_1.Type.Optional(dumpster_activity_record_transport_1.DumpsterActivityRecordTransport),
    history: typebox_1.Type.Array(dumpster_activity_record_transport_1.DumpsterActivityRecordTransport),
    metadata: common_1.MetaData,
});
exports.DumpsterCreateInput = typebox_1.Type.Omit(exports.DumpsterTransport, [
    'id',
    'history',
    'metadata',
    'haulerID',
    'currentLocation',
    'history',
]);
exports.DumpsterUpdateInput = typebox_1.Type.Omit(exports.DumpsterTransport, [
    'id',
    'history',
    'metadata',
    'haulerID',
    'currentLocation',
    'history',
]);
//# sourceMappingURL=dumpster-transport.js.map